<template>
  <Fragment v-if="link === undefined || targetProtocolType === undefined">
    <slot />
  </Fragment>
  <ProtocolLinkContainer
    v-else
    :value="value"
    :link="link"
    :element="element"
    :edit="edit"
    @input="$emit('input', $event)"
  >
    <slot />
  </ProtocolLinkContainer>
</template>

<script lang="ts">
import { Element } from '@anschuetz-elog/common';
import { computed, defineComponent, PropType, toRef } from 'vue';

import useFeathers from '#/compositions/useFeathers';

import ProtocolLinkContainer from './ProtocolLinkContainer.vue';
import { ProtocolLinkConfigProp } from './utils';

export default defineComponent({
  name: 'ProtocolLinkWrapper',

  components: {
    ProtocolLinkContainer,
  },

  props: {
    value: {
      type: Object as PropType<Record<string, unknown>>,
      default: () => ({}),
    },

    element: {
      type: Object as PropType<Element>,
      required: true,
    },

    edit: {
      type: Boolean,
    },

    link: {
      type: Object as PropType<ProtocolLinkConfigProp | undefined>,
      default: undefined,
    },
  },

  emits: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    input: (_value: Record<string, unknown>) => true,
  },

  setup(props) {
    const link = toRef(props, 'link');

    const feathers = useFeathers();
    const localCache = feathers.get('localCache');

    const targetProtocolType = computed(() => {
      if (!link.value) {
        return undefined;
      }
      return localCache.getProtocolType(link.value.target.protocolType._id);
    });

    return {
      targetProtocolType,
    };
  },
});
</script>
